import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import moment from 'moment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '../shared/services/notification.sevice';
import { Account, AccountService, PaymentRequestTaskService, UnattendedPaymentRequestTaskInput } from '../shared/_generated/backend';
import { determinePayeeAccountNumber, errorHandler } from '../helpers/form-helper';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-init-unattended',
    templateUrl: './init-unattended.component.html',
    styleUrl: './init-unattended.component.scss',
    standalone: false
})
export class InitUnattendedComponent implements OnInit {

    accounts: Account[] = [];

    initUnattendedForm = this.fb.nonNullable.group({
        validityDate: ['', [Validators.required]],
        deadline: ['', [Validators.required]],
        payee: [null, [Validators.required]],
        payer: this.fb.nonNullable.group({
            accountNumber: ['', [Validators.required]],
            name: ['', [Validators.required]]
        }),
        amount: [10, [Validators.required, Validators.min(1)]],
        amountModifiable: [false, [Validators.required]],
        comment: ['']
    });

    constructor(
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private accountService: AccountService,
        private paymentRequestTaskService: PaymentRequestTaskService,
        public dialog: MatDialog
    ) { }

    async ngOnInit() {
        this.initUnattendedForm.controls.validityDate.setValue(moment().add(60, 'days').toISOString());
        this.initUnattendedForm.controls.deadline.setValue(moment().add(60, 'days').toISOString());

        this.accounts = await firstValueFrom(this.accountService.getAccounts());

        if (this.accounts.length === 1) {
            this.initUnattendedForm.controls.payee.setValue(this.accounts[0] as any);
        }

        this.setRequiredBasedOnModifiable(this.initUnattendedForm.controls.amountModifiable, this.initUnattendedForm.controls.amount);
    }

    openConfirmDialog() {
        const formValue = this.initUnattendedForm.getRawValue();

        const dialogRef: MatDialogRef<ConfirmDialogComponent, 'yes'> = this.dialog.open(
            ConfirmDialogComponent,
            { data: { type: 'unattended', paymentRequest: formValue } }
        );

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.submit();
            }
        });
    }

    async submit() {
        try {
            const formValue = this.initUnattendedForm.getRawValue();

            const input: UnattendedPaymentRequestTaskInput = {
                ...formValue,
                validityDate: moment(formValue.validityDate).format('YYYY-MM-DD'),
                deadline: new Date(formValue.deadline),
                payee: {
                    accountNumber: determinePayeeAccountNumber(formValue)
                }
            };

            // fix default value of empty field
            if (input.comment === null || input.comment === '') {
                delete input.comment;
            }

            const response = await firstValueFrom(this.paymentRequestTaskService.initUnattended(input));
            if (response.error) {
                this.notificationService.showErrorSnackBar(`Hiba: ${response.error}`);
            } else {
                this.notificationService.showSuccessSnackBar(`Sikeres létrehozás! Azonosító: ${response.paymentRequestTaskId}`);
            }

        } catch (error: any) {
            errorHandler(error, this.notificationService);
        }
    }

    private setRequiredBasedOnModifiable(modifiableControl: FormControl<boolean>, inputControl: FormControl) {
        modifiableControl.valueChanges.subscribe(modifiable => {
            if (modifiable) {
                inputControl.removeValidators(Validators.required);
            } else {
                inputControl.addValidators(Validators.required);
            }
            inputControl.updateValueAndValidity();
        });
    }
}
